<script lang="ts">
    import { getRoleIcon } from "$lib/utils/images";
    import ToggleGroup from "./ToggleGroup.svelte";

    const ROLES = [
        { value: "all", label: "All" },
        { value: "tank", label: "Tank" },
        { value: "damage", label: "Damage" },
        { value: "support", label: "Support" },
    ];

    let {
        value = $bindable("all"),
        onchange,
    }: {
        value?: string;
        onchange?: () => void;
    } = $props();
</script>

<ToggleGroup options={ROLES} bind:value onchange={() => onchange?.()}>
    {#snippet option(opt, isActive)}
        {@const icon = opt.value !== "all" ? getRoleIcon(opt.value) : null}
        {#if icon}
            <img
                src={icon}
                alt={opt.label}
                width="20"
                height="20"
                class="brightness-0 invert transition-opacity {isActive ? 'opacity-100' : 'opacity-60'}"
            />
        {:else}
            <span class="text-sm font-semibold {isActive ? 'text-primary' : 'text-base-content/60'}">{opt.label}</span>
        {/if}
    {/snippet}
</ToggleGroup>
